import {
    Tooltip as AriaTooltip,
    type TooltipProps as AriaTooltipProps,
    TooltipTrigger,
    composeRenderProps,
} from 'react-aria-components';

import { classnames } from '@/utils/classnames.ts';

export interface TooltipProps extends Omit<AriaTooltipProps, 'children'> {
    label: React.ReactNode;
    // Must be a focusable react-aria element (Button, Link) or wrapped in react-aria's Focusable.
    children: React.ReactElement;
    delay?: number;
    isDisabled?: boolean;
}

const Tooltip = ({ label, children, delay = 400, isDisabled, className, offset = 8, ...props }: TooltipProps) => (
    <TooltipTrigger delay={delay} isDisabled={isDisabled}>
        {children}
        <AriaTooltip
            offset={offset}
            {...props}
            className={composeRenderProps(className, (className) =>
                classnames(
                    // react-aria can mount a tooltip that is already closing (fast pointer moves between triggers);
                    // it never gets positioned and would flash at the top left, so it stays hidden until placed.
                    'rounded-md bg-primary px-2 py-1 text-xs font-medium text-on-primary shadow-sm not-data-placement:hidden',
                    className
                )
            )}
        >
            {label}
        </AriaTooltip>
    </TooltipTrigger>
);

export default Tooltip;
